import { useReducer } from 'react';

const defaultCredentials = {
  'API Key': { key: '', value: '', add_to_header: true },
  'Basic Auth': { username: '', password: '' },
  'Bearer Token': { token: '' },
  'No Auth': {},
  OAuth2: {
    client_id: '',
    client_secret: '',
    token_url: '',
    grant_type: 'client_credentials',
    authorize_url: '',
    scopes: '',
    extra_authorize_params: ''
  }
};

const reducer = (state, { type, newType, newCredentials }) => {
  switch (type) {
    case 'CHANGE_TYPE':
      return {
        type: newType,
        credentials: defaultCredentials[newType]
      };
    case 'CHANGE_CREDENTIALS':
      return { ...state, credentials: newCredentials };
    default:
      throw new Error();
  }
};

const types = ['API Key', 'Basic Auth', 'Bearer Token', 'No Auth', 'OAuth2'];

const defaultAuth = {
  type: 'Bearer Token',
  credentials: { token: '' }
};

const useAuth = (initialAuth = defaultAuth) => {
  const [state, dispatch] = useReducer(reducer, initialAuth);

  const handleChangeType = option => {
    dispatch({ type: 'CHANGE_TYPE', newType: option ? option.value : null });
  };

  const handleCredentialsChange = credentials => {
    dispatch({ type: 'CHANGE_CREDENTIALS', newCredentials: credentials });
  };

  const validWithCreds =
    state.type &&
    state.credentials &&
    Object.values(state.credentials).every(Boolean);
  const validWithoutCreds = Boolean(state.type);

  return {
    ...state,
    form: state,
    dispatch,
    valid: validWithCreds || validWithoutCreds,
    handleChangeType,
    handleCredentialsChange
  };
};

export default useAuth;
export { defaultAuth, defaultCredentials, types, reducer };
